module.exports = __webpack_public_path__ + "static/media/BricolageGrotesque-ExtraLight.0e66297d.ttf";